import MuiPopper, { type PopperProps } from "@mui/material/Popper";

export type { PopperProps };

export function Popper(props: PopperProps) {
  return <MuiPopper {...props} />;
}
